import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  path: string;
}

export function usePageMeta({ title, description, path }: PageMeta) {
  useEffect(() => {
    document.title = title;
    // We could also update meta tags here if needed
  }, [title, description, path]);
}
